"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f39 = void 0;
exports.f39 = {
    "'are'are": [
        277
    ],
    "'ôrôê": [
        1034
    ],
    "'auhelawa": [
        4017
    ]
};
